<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="卡号:">
            <el-input v-model="querycardno" placeholder="请输入查询"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form ref="form" style="margin-left: 20px;" label-width="120px" label-position="left">
          <el-form-item label="卡类别选择:">
            <el-select v-model="cardtype" filterable placeholder="请选择卡分类" @change="ordertypechange">
              <el-option
                v-for="item in cardtypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div style="display: flex;flex-flow: row;">
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querycard">查询开卡信息</el-button>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="outputorder">导出Excel</el-button>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="importcardset">导入配置</el-button>
          <el-upload
            ref="upload"
            style="margin-top: 10px; margin-left: 10px;"
            action="/"
            :show-file-list="false"
            :on-change="importorderExcel"
            :auto-upload="false">
            <el-button
              icon="el-icon-upload"
              type="primary">
              导入预售配送单
            </el-button>
          </el-upload>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        id="carddataid"
        :data="carddata"
        ref="multipleTable">
        <el-table-column
          prop="cardno"
          width = "200px"
          label="卡号">
        </el-table-column>
        <el-table-column
          prop="username.String"
          width = "100px"
          label="开卡人">
        </el-table-column>
        <el-table-column
          prop="pstime.String"
          width = "100px"
          label="配送日期">
        </el-table-column>
        <el-table-column
          prop="pstimes"
          width = "100px"
          label="全部次数">
        </el-table-column>
        <el-table-column
          prop="sytimes"
          width = "100px"
          label="配送次数">
        </el-table-column>
        <el-table-column
          label="配送地址">
          <template slot-scope="scope">
            {{scope.row.shengid.String}}{{scope.row.shiid.String}}{{scope.row.dq.String}}{{scope.row.ssaddress.String}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看配送详情" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seeps(scope.$index, carddata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="发货" placement="top-start">
              <i class="fa fa-truck fa-lg ciicon curpointer" v-on:click="sendorder(scope.$index, carddata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="作废该订单" placement="top-start">
              <i class="fa fa-trash-o fa-lg ciicon curpointer" v-on:click="delorder(scope.$index, carddata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="配送详情" :visible.sync="psdetailvisible">
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单编号:">{{curorderno}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单日期:">{{curorderdate}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="下单人:">{{curorderbuyuser}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="订单状态:">{{curorderstate}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="订单备注:">{{curorderdes}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="购买清单:"></el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <div class="showpcinfo" style="margin-top: 10px;">
        <el-table
          stripe
          showSummary
          :data="orderdetaildata"
          ref="multipleTable">
          <el-table-column
            label="图片">
            <template slot-scope="scope">
              <div v-if="scope.row.imgurl.Valid && scope.row.imgurl.String !== ''">
                <img :src="scope.row.imgurl.String" class="goodsavatarimg">
              </div>
              <div v-else>
                {{scope.row.imgurl.String}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="barcode.String"
            label="产品编码">
          </el-table-column>
          <el-table-column
            prop="name.String"
            width = "280px"
            label="商品名称">
          </el-table-column>

          <el-table-column
            prop="specinfo.String"
            label="规格">
          </el-table-column>
          <el-table-column
            prop="price.String"
            label="单价">
          </el-table-column>
          <el-table-column
            prop="count.Int64"
            label="数量">
          </el-table-column>
          <el-table-column
            label="总价"
            width="80px"
          >
            <template slot-scope="scope">
              {{scope.row.count.Int64*scope.row.price.String}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row style="flex:1;color: #000; margin-top: 40px;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="收货地址:"></el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="收货人姓名:">{{shname}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="联系方式:">{{shcontact}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="所属省市:">{{shssaddress}}</el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="queryinput">
              <el-form-item label="邮编:">{{shzipcode}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="flex:1;color: #000;">
        <el-form>
          <el-col :span="24">
            <div class="queryinput">
              <el-form-item label="详细地址:">{{shaddressex}}</el-form-item>
            </div>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="ordershvisible">
      <div class="showpcinfo">
      <el-table
        stripe
        :data="ordershdata"
        ref="multipleTable">
        <el-table-column
          prop="username.String"
          width = "280px"
          label="收货人">
        </el-table-column>
        <el-table-column
          prop="shengname.String"
          label="省">
        </el-table-column>
        <el-table-column
          prop="shiname.String"
          label="市">
        </el-table-column>
        <el-table-column
          prop="address.String"
          label="收货地址">
        </el-table-column>
        <el-table-column
          prop="contact.String"
          label="联系方式">
        </el-table-column>
      </el-table>
    </div>
    </el-dialog>
    <el-dialog title="物流发货" :visible.sync="wuliuvisible">
      <div class="showpcinfo">
        <el-form  label-width="120px">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form label-width="120px" label-position="left">
                <el-form-item label="卡号:">
                  <el-input v-model="ddno" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="物流公司选择:">
                  <el-select v-model="wuliuinfo" filterable placeholder="请选择物流公司" >
                    <el-option
                      v-for="item in wuliulist"
                      :key="item.id.Int64"
                      :label="item.lname"
                      :value="item.id.Int64"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流单号:" >
                  <el-input v-model="wlno" placeholder="请输入物流单号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="物流费用(元):" style="margin-left: 20px;">
                  <el-input v-model="wlprice" placeholder="请输入物流费用"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="配送人员:" >
                  <el-input v-model="wlman" placeholder="请输入物流单号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="联系方式:" >
                  <el-input v-model="wlcontact" placeholder="请输入物流单号"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-top: 20px" @click="savekdinfo">发货</el-button>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="wlddvisiable">
      <div class="showpcinfo">
        <el-table
          stripe
          :data="wuliuorder"
          ref="multipleTable">
          <el-table-column
            prop="cardno"
            label="卡号">
          </el-table-column>
          <el-table-column
            prop="lname.String"
            label="三方物流名称">
          </el-table-column>
          <el-table-column
            prop="wlno.String"
            label="物流单号">
          </el-table-column>
          <el-table-column
            prop="wlman.String"
            label="配送人">
          </el-table-column>
          <el-table-column
            prop="wlcontact.String"
            label="联系方式">
          </el-table-column>
          <el-table-column
            label="配送地址">
            <template slot-scope="scope">
              {{scope.row.shengid.String}}{{scope.row.shiid.String}}{{scope.row.dq.String}}{{scope.row.ssaddress.String}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="作废该订单" placement="top-start">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="delpsrec(scope.$index, wuliuorder)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="导入配置" :visible.sync="importsetvis">
      <el-button style="margin-top: 10px" @click="downcardtemp">下载导入模板</el-button>
      <div style="color: darkolivegreen; margin-left: 5px; margin-top: 20px;margin-bottom: 10px;">配送状态：参考值0和1，默认为1 (0=未配送，1=已配送)</div>
      <div style="color: #8a8a8a; margin-left: 5px; margin-top: 20px;margin-bottom: 10px;">物流公司ID参考：</div>
      <div class="showpcinfo">
        <el-table
          stripe
          :data="wlgsdata"
          ref="multipleTable">
          <el-table-column
            prop="id.Int64"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="lname"
            label="物流名称">
          </el-table-column>
          <el-table-column
            prop="lcontact"
            label="物流单号">
          </el-table-column>
        </el-table>
      </div>
      <div style="color: #8a8a8a; margin-left: 5px; margin-top: 20px;margin-bottom: 10px;">配送地址ID参考：</div>
      <div class="showpcinfo">
        <el-table
          stripe
          :data="psdzdata"
          ref="multipleTable">
          <el-table-column
            prop="id.Int64"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="username.String"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="contact.String"
            label="电话">
          </el-table-column>
          <el-table-column
            label="配送地址">
            <template slot-scope="scope">
              {{scope.row.shengid.String}}{{scope.row.shiid.String}}{{scope.row.dq.String}}{{scope.row.ssaddress.String}}
            </template>
          </el-table-column>
          <el-table-column
            prop="areacode.String"
            label="邮编">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import Utils from '../../util/utils'
import ElForm from '../../../node_modules/element-ui/packages/form/src/form'
import ElFormItem from '../../../node_modules/element-ui/packages/form/src/form-item'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import { Dialog } from 'vant';
Vue.prototype.$http = axios
Vue.use(Dialog);
var that
export default {
  components: {
    ElFormItem,
    ElForm},
  name: 'OrderInfo',
  data () {
    return {
      querycardno:'',
      curorderno: '',
      curorderdate: '',
      curorderbuyuser: '',
      wlddvisiable: false,
      curorderstate: '',
      importsetvis: false,
      psdzdata: [],
      selpsdata: '',
      shzipcode: '',
      shname: '',
      shcontact: '',
      shssaddress: '',
      shaddressex: '',
      curorderdes: '',
      carddata: [],
      ordershdata: [],
      byorderdate: '',
      orderdetaildata: [],
      ifhiddentruck: true,
      ifhiddenqueren: true,
      wuliuvisible: false,
      ddno: '',
      wlno: '',
      wlprice: '',
      wlman: '',
      wlcontact: '',
      xfcount: '',
      viplevels: '',
      buyuserid: '',
      cardtypelist: [{
        value: 1,
        label: '年卡'
      }, {
        value: 2,
        label: '季卡'
      }, {
        value: 3,
        label: '双年卡'
      }],
      cardtype: '',
      orderstate: '',
      seldata: '',
      automlevel: '0',
      psdetailvisible: false,
      ordershvisible: false,
      wuliulist: [],
      wuliuinfo: '',
      wuliuorder: [],
      orderstatelist: [{
        value: 0,
        label: '所有状态'
      }, {
        value: 1,
        label: '待付款'
      }, {
        value: 2,
        label: '已付款待发货'
      }, {
        value: 3,
        label: '已发货待确认'
      }, {
        value: 4,
        label: '已确认'
      }, {
        value: 5,
        label: '已评价'
      }, {
        value: 6,
        label: '已分账'
      }]
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr1 = 'cusid = ' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gotl',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.wuliulist = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      that.$options.methods.getwlgsdata()
      that.$options.methods.getpsdzdata()
    }
  },
  methods: {
    downcardtemp () {
      var xlsdata = []
      var xlstmp = {
        '卡号': '',
        '配货日期': '',
        '配送状态': '',
        '配送地址ID': '',
        '物流公司ID': '',
        '物流单号': '',
        '配送人员': '',
        '配送联系方式': '',
        '配送费': '',
        '发货时间': ''
      }
      xlsdata.push(xlstmp)
      window.console.log('订单导出信息')
      window.console.log(xlsdata)
      // 表名
      var ws = XLSX.utils.json_to_sheet(xlsdata);
      /* get binary string as output */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '导入预售卡配送模板');
      /* 生成xlsx文件 */
      XLSX.writeFile(wb, '导入预售卡配送模板.xlsx');
    },
    getwlgsdata () {
      var qstr = 'cusid = ' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gotl',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.wlgsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getpsdzdata () {
      var qstr = 'cusid = ' + that.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbua',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.psdzdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    importcardset () {
      this.importsetvis = true
    },
    file2Xce(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        reader.onload = function(e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        reader.readAsBinaryString(file.raw)
        // reader.readAsBinaryString(file)     //使用原始input方法
      })
    },
    importorderExcel (file) {
      const types = file.name.split('.')[1]
      const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
      if (!fileType) {
        this.$message('格式错误！请重新选择')
        return
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson
          console.log('数据:', this.xlsxJson)
          var idatas = []
          for (var i = 0; i < this.xlsxJson[0].sheet.length; i++) {
            var tmpdata = this.xlsxJson[0].sheet[i]
            var fhtime = ''
            if (tmpdata.发货时间) {
              fhtime = tmpdata.发货时间.toString()
            }
            var adata = {
              cardno: tmpdata.卡号.toString(),
              pstime: {String: tmpdata.配货日期.toString(), Valid: true},
              psstate: parseInt(tmpdata.配送状态),
              psaddressid: parseInt(tmpdata.配送地址ID),
              wlid: parseInt(tmpdata.物流公司ID),
              wlno: {String: tmpdata.物流单号.toString(), Valid: true},
              wlman: {String: tmpdata.配送人员.toString(), Valid: true},
              wlcontact: {String: tmpdata.配送联系方式.toString(), Valid: true},
              wlprice: {String: tmpdata.配送费.toString(), Valid: true},
              optime: fhtime,
              cusid: parseInt(that.khid)
            }
            idatas.push(adata)
          }
          window.console.log(idatas)
          that.$http({
            url: 'https://api.sqnetsoft.cn/order/paaubtcps',
            method: 'post',
            data: idatas,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                that.$message({
                  type: 'success',
                  message: '配送信息导入完毕!'
                })
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        if (index === 5) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 个'
          } else {
            sums[index] = 'N/A'
          }
        }
        if (index === 6) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 元'
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    },
    querycard () {
      var qstr = 'cusid =' + that.khid
      if (that.querycardno !== null && that.querycardno !== '' && that.querycardno !== 0) {
        qstr = qstr + " and cardno like '%" + that.querycardno + "%' "
      }
      if (that.cardtype !== null && that.cardtype !== '') {
        qstr = qstr + ' and cardtype >= ' + that.cardtype
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbtci',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.carddata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    printorder () {},
    changeprice (index, data) {
      var pricedata = data[index]
      console.log(pricedata)
      this.$prompt('请输入新的价格', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        var qstr = "order_no ='" + pricedata.orderno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/upboi',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            fieldparams: {String: ' count_price=' + value, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已更新订单价格!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消价格变更'
        })
      })
    },
    seeordersh (index, data) {
      console.log(data[index])
      this.ordershvisible = true
    },
    seeorder (index, data) {
      var ddata = data[index]
      console.log(ddata)
      this.curorderno = ddata.orderno
      this.curorderdate = ddata.optime
      this.curorderbuyuser = ddata.name.String
      this.curorderstate = this.orderstatelist[ddata.stateid].label
      this.psdetailvisible = true
      var qstr = "order_no ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/god',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('查看订单详情')
            console.log(JSON.parse(res.data.data))
            that.orderdetaildata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var qstr1 = "orderno ='" + ddata.orderno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbuae',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              console.log(JSON.parse(res.data.data))
              var tmpdata = JSON.parse(res.data.data)[0]
              that.shzipcode = tmpdata.zipcode.String
              that.shname = tmpdata.username.String
              that.shcontact = tmpdata.contact.String
              that.curorderdes = tmpdata.uword.String
              that.shssaddress = tmpdata.shengid.String + tmpdata.shiid.String + tmpdata.dq.String
              that.shaddressex = tmpdata.ssaddress.String
            } else {
              that.shzipcode = ''
              that.shname = ''
              that.shcontact = ''
              that.shssaddress = ''
              that.curorderdes = ''
              that.shaddressex = ''
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    jhcard (index, data) {},
    delorder (index, data) {
      console.log(data[index])
      this.$confirm('您确定要作废该该预售卡嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var ddata = data[index]
        var qstr = "cardno ='" + ddata.cardno + "'"
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/delbtci',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.carddata.splice(index, 1)
              that.$options.methods.querycard()
              that.$message({
                type: 'success',
                message: '已删除订单信息!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    },
    delpsrec (index, data) {
      this.$confirm('您确定要删除该配送记录嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var ddata = data[index]
        var qstr = 'id =' + ddata.id.Int64
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/delbtcps',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.wuliuorder.splice(index, 1)
              that.$options.methods.downtimes(ddata.cardno)
              that.$message({
                type: 'success',
                message: '已删除卡配送记录!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      })
    },
    orderstatechange () {
    },
    ordertypechange () {},
    querypsorder () {
      var qstr = "cardno ='" + that.selpsdata.cardno + "'"
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/getbtcps',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('查看订单详情')
            console.log(JSON.parse(res.data.data))
            that.wuliuorder = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeps (index, data) {
      this.selpsdata = data[index]
      window.console.log(this.selpsdata)
      this.wlddvisiable = true
      that.$options.methods.querypsorder()
    },
    sendorder (index, data) {
      console.log(data[index])
      this.wuliuvisible = true
      this.ddno = data[index].cardno
      this.seldata = data[index]
    },
    uppstimes (cardno) {
      var qstr = 'cardno = \'' + cardno + '\''
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/upbtci',
        method: 'post',
        data: {
          whereinfo: { String: qstr, Valid: true },
          fieldparams: { String: ' sytimes = sytimes + 1', Valid: true }
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            window.console.log('更新次数完毕')
            that.wuliuvisible = false
            that.$options.methods.querycard()
          } else {
            window.console.log('地址添加失败')
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    downtimes (cardno) {
      var qstr = 'cardno = \'' + cardno + '\''
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/upbtci',
        method: 'post',
        data: {
          whereinfo: { String: qstr, Valid: true },
          fieldparams: { String: ' sytimes = sytimes - 1', Valid: true }
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            window.console.log('更新次数完毕')
            that.wuliuvisible = false
            that.$options.methods.querycard()
          } else {
            window.console.log('地址添加失败')
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    savekdinfo () {
      let nowStr = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var adata = {
        cardno: that.seldata.cardno,
        pstime: {String: that.seldata.pstime.String, Valid: true},
        psstate: parseInt(1),
        psaddressid: that.seldata.psaddressid,
        wlid: that.wuliuinfo,
        wlno: {String: that.wlno, Valid: true},
        wlman: {String: that.wlman, Valid: true},
        wlprice: {String: that.wlprice, Valid: true},
        wlcontact: {String: that.wlcontact, Valid: true},
        optime: nowStr,
        cusid: parseInt(that.khid)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/aaubtcps',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$options.methods.uppstimes(that.seldata.cardno)
            that.$message({
              type: 'success',
              message: '物流信息保存完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      window.console.log(adata)
    },
    outputorder () {
      // 表名
      var wb = XLSX.utils.table_to_book(document.querySelector('#carddataid'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'order.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/order/CardOrderInfo.vue